import { COLORS } from '@/constants';

export const ColorGrid = ({ value, onChange }: { value: string; onChange: (code: string) => void }) => (
    <div className="flex flex-wrap gap-1">
        <button
            type="button"
            onClick={() => onChange('')}
            className="relative size-4 cursor-pointer rounded-full overflow-hidden hover:opacity-70"
            style={value === '' ? { outline: '1px solid #000' } : undefined}
        >
            <span className="absolute bottom-[-20%] left-1/2 h-[140%] w-px rotate-45 bg-secondary" />
        </button>
        {COLORS.filter(c => c.code !== 'colorX').map(({ code, color }) => (
            <button
                key={code}
                type="button"
                onClick={() => onChange(code)}
                className="size-4 cursor-pointer rounded-full hover:brightness-125"
                style={{
                    background: color,
                    ...(value === code ? { outline: '1px solid #000' } : undefined),
                }}
            />
        ))}
    </div>
);
